/* unplugin-vue-components disabled */import { render } from "./goalsUnlockHelp.vue?vue&type=template&id=11e6936e&scoped=true"
import script from "./goalsUnlockHelp.vue?vue&type=script&lang=js"
export * from "./goalsUnlockHelp.vue?vue&type=script&lang=js"

import "./goalsUnlockHelp.vue?vue&type=style&index=0&id=11e6936e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e6936e"]])

export default __exports__